module.exports = __webpack_public_path__ + "img/policy_match.466bdad0.png";